import React from 'react'
import styles from './Chip.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

import { MdCheckCircle } from 'react-icons/md'

import classNames from 'classnames'

const Chip = ({
  alert = false,
  closeButtonIcon,
  image,
  startIcon,
  invalid = false,
  valid = false,
  ...props
}) => {
  const activateFirstIcon = startIcon && !image
  const activateImage = image && !startIcon
  const activateCancelButton = !valid && closeButtonIcon
  const activateValidIcon = valid && !closeButtonIcon
  const activePointerClick = props.onClick
  const tabIndexChip = !props.disabled ? 1 : 0

  function getTypeChip() {
    if (!image && !startIcon) {
      return styles.chip_label
    } else if (startIcon) {
      return styles.chip_icon
    } else if (image) {
      return styles.chip_image
    }
  }

  function getStateChip() {
    if (props.disabled) {
      return styles.chip_disabled
    } else if (invalid) {
      return styles.chip_invalid
    } else if (alert) {
      return styles.chip_alert
    }
  }

  const { className, ...rest } = props;
  const childrenClassNames = classNames([
    generalStyle.general_style,
    activePointerClick && generalStyle.clickable,
    generalStyle.noselect,
    styles.chip,
    getTypeChip(),
    getStateChip(),
  ], className)

  return (
    <div
      className={childrenClassNames}
      tabIndex={tabIndexChip}
      {...rest}
    >
      {activateImage && image}
      {activateFirstIcon && startIcon}
      {props.children}
      {activateValidIcon && <MdCheckCircle size={13} />}
      {activateCancelButton && closeButtonIcon}
    </div>
  )
}

export { Chip }
